import { render, staticRenderFns } from "./EditServiceLogs.vue?vue&type=template&id=3a48dfe3"
import script from "./EditServiceLogs.vue?vue&type=script&lang=js"
export * from "./EditServiceLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports